/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fetchAll} from '../api'

export const useMutationFetchAll = createReactQueryMutationHook('fetchAll', fetchAll)
